import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BookOpen, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const KbNewsBanner = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/knowledge/news`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  if (!items.length) return null;

  const markSeen = async () => {
    const ids = items.map((i) => i.id);
    setItems([]);
    await axios.post(`${API_URL}/knowledge/news/seen`, { ids }).catch(() => {});
  };

  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 flex flex-wrap items-start gap-3" data-testid="kb-news-banner">
      <BookOpen className="w-5 h-5 text-emerald-700 mt-0.5" />
      <div className="flex-1 min-w-[220px]">
        <p className="text-sm font-semibold text-emerald-900">
          Há {items.length} documento{items.length > 1 ? 's' : ''} novo{items.length > 1 ? 's' : ''} na Base de Conhecimento
        </p>
        <ul className="mt-1 space-y-0.5">
          {items.slice(0, 5).map((it) => (
            <li key={it.id} className="text-xs text-emerald-800">
              {it.aviso_tipo === 'tarifarios' ? '💶 Tarifários' : '📄 Formulário'} {(it.empresa || '').replace('_', ' ').toUpperCase()}:{' '}
              <Link to={`/knowledge?file=${it.id}`} className="underline font-medium" data-testid={`kb-news-link-${it.id}`}>{it.name}</Link>
              {it.replaces_name && <span className="text-emerald-600"> (substitui "{it.replaces_name}")</span>}
            </li>
          ))}
        </ul>
      </div>
      <button type="button" onClick={markSeen} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-emerald-600 text-white hover:bg-emerald-700 flex items-center gap-1" data-testid="kb-news-seen-btn">
        <Check className="w-3.5 h-3.5" /> Visto
      </button>
    </div>
  );
};
